module.exports = __webpack_public_path__ + "static/media/Horni_hory_Straznice.19dd5f48.md";